import { render, staticRenderFns } from "./data-subpage.vue?vue&type=template&id=36783d69&lang=pug&"
import script from "./data-subpage.vue?vue&type=script&lang=js&"
export * from "./data-subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports